<template>
  <footer>
    <slot name="cancel">
      <base-button class="button minimal sml" @click="$emit('cancel')">
        <translate>Cancel</translate>
      </base-button>
    </slot>
    <base-button class="tiny icon minimal clear" @click="$emit('clear')">
      <img loading="lazy" src="@/assets/images/refresh.svg" class="icon" />
      <translate>Clear search</translate>
    </base-button>
  </footer>
</template>
<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  emits: ['clear', 'cancel'],
})
class WizardFooter extends Vue {}

export default toNative(WizardFooter)
</script>

<style scoped>
footer {
  margin: 2em 0 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

button {
  flex-shrink: 0;
}

button.clear {
  font-size: var(--body);
}

button .icon {
  height: 1.2em;
  margin: 0em 0.1em 0 0;
}
</style>
